import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  gap: 4px;
`;

const Btn = styled.button`
  padding: 4px 12px;
  border: 1px solid ${(p) => (p.$active ? '#667eea' : '#d1d5db')};
  background: ${(p) => (p.$active ? '#667eea' : '#fff')};
  color: ${(p) => (p.$active ? '#fff' : '#374151')};
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    background: ${(p) => (p.$active ? '#5a6fd6' : '#f3f4f6')};
  }
`;

export default function PeriodSelector({ value, onChange, options = ['24h', '7d', '30d'], renderLabel }) {
  return (
    <Wrapper>
      {options.map((o) => (
        <Btn key={o} $active={value === o} onClick={() => onChange(o)}>
          {renderLabel ? renderLabel(o) : o}
        </Btn>
      ))}
    </Wrapper>
  );
}
